import { CheckboxProps } from "@/src/common/types"
import React, { useEffect, useRef } from "react"

const Checkbox: React.FC<CheckboxProps> = ({
  id,
  checked,
  onChange,
  label,
  name,
  disabled,
  wrapLabel,
  indeterminate = false,
  onLabelClick
}) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const isIndeterminate = indeterminate && !checked

  // `indeterminate` is a DOM property only, so it can't be set via JSX
  useEffect(() => {
    if (inputRef.current) inputRef.current.indeterminate = isIndeterminate
  }, [isIndeterminate])

  return (
    <div
      className={`flex min-w-0 items-start ${
        disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
      }`}
    >
      <label htmlFor={id} className="flex min-w-0 items-start">
        <div
          className={`relative w-[16px] h-[16px] border-[0.5px] shrink-0 dark:border-[#4B5563] bg-gray-200 dark:bg-[#1A1D21] ${
            disabled ? "cursor-not-allowed" : "cursor-pointer"
          }`}
        >
          <input
            ref={inputRef}
            type="checkbox"
            id={id}
            name={name}
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            className="hidden peer"
          />
          <div className="hidden top-0 left-0 absolute w-full h-full peer-checked:flex justify-center items-center border-[0.5px] dark:border-white bg-gray-200 dark:bg-[#1A1D21] dark:text-white">
            <span>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.6515 5.1415C11.8495 4.94901 12.166 4.95347 12.3585 5.15146C12.551 5.34945 12.5465 5.666 12.3485 5.8585L7.20568 10.8585C7.01162 11.0472 6.70266 11.0472 6.5086 10.8585L3.65146 8.08072C3.45347 7.88823 3.44901 7.57168 3.6415 7.37368C3.834 7.17569 4.15055 7.17123 4.34854 7.36373L6.85714 9.80265L11.6515 5.1415Z"
                  fill="currentColor"
                />
              </svg>
            </span>
          </div>
          {isIndeterminate && (
            <div className="top-0 left-0 absolute w-full h-full flex justify-center items-center border-[0.5px] dark:border-white bg-gray-200 dark:bg-[#1A1D21] dark:text-white">
              <span className="block w-2 h-[1.5px] bg-current" />
            </div>
          )}
        </div>
        <span
          onClick={
            onLabelClick
              ? (event) => {
                  // Stop the label from toggling the checkbox
                  event.preventDefault()
                  onLabelClick()
                }
              : undefined
          }
          className={`min-w-0 text-xs font-normal cursor-pointer capitalize text-gray-700 ${
            wrapLabel
              ? "whitespace-normal break-words [overflow-wrap:anywhere]"
              : "whitespace-nowrap"
          } ${checked || isIndeterminate ? "text-white" : "dark:text-[#9CA3AF]"}
      ml-2 cursor-default`}
        >
          {label}
        </span>
      </label>
    </div>
  )
}

export default Checkbox
